import { render } from "./ReportEmailerConfig.vue?vue&type=template&id=5fa85828&scoped=true"
import script from "./ReportEmailerConfig.vue?vue&type=script&lang=js"
export * from "./ReportEmailerConfig.vue?vue&type=script&lang=js"

import "./ReportEmailerConfig.vue?vue&type=style&index=0&id=5fa85828&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa85828"]])

export default __exports__